<template>
  <section id="dashboard">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h6 class="mb-sm-0 pt-2">
          <a href="/dashboard">Home Page</a><span>/</span><span>Dashboard</span>
        </h6>
      </div>
    </div>
    <section class="mt-lg-5">
      <mdb-row>
        <mdb-col md="3" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="user-graduate" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Total Students</h6>
                <h6 class="">
                  <strong class="white-text pr-2">{{ totalStudents }}</strong>
                </h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/students" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm" v-if="permissions.includes('All') || permissions.includes('Students')">
                  View Students
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="3" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="user-graduate" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Pending Students</h6>
                <h6 class="">
                  <strong class="white-text pr-2">{{ pendingStudents }}</strong>
                </h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/pending-students" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm" v-if="permissions.includes('All') || permissions.includes('Pending Students')">
                  View Pending Students
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="3" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="users" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Total Teachers</h6>
                <h6 class="">
                  <strong class="white-text pr-2">{{ totalTeachers }}</strong>
                </h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/teachers/view-account" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm" v-if="permissions.includes('All') || permissions.includes('Teachers')">
                  View Teachers
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="3" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="level-up-alt" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Total Levels</h6>
                <h6 class="">
                  <strong class="white-text pr-2">{{ totalLevels }}</strong>
                </h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/levels/view-level/all" @click.native="activeItem = 4" v-if="permissions.includes('All') || permissions.includes('Levels')">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Levels
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r" v-if="permissions.includes('All') || permissions.includes('Report')">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="file-alt" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Reports</h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/report" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Reports
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r" v-if="permissions.includes('All') || permissions.includes('Report')">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="file-alt" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">All Group Weekly Report</h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/weekly-report" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Reports
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r" v-if="permissions.includes('All') || permissions.includes('Report')">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="file-alt" fas class="bg-dark" />
              <div class="data py-3">
                <h6 class="white-text font-weight-bold">Bourdon Report</h6>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/bourdon-report" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Reports
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>
  </section>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon } from "mdbvue";

export default {
  name: "Dashboard",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbIcon,
  },
  data() {
    return {
      totalStudents: "",
      pendingStudents: 0,
      totalTeachers: "",
      totalLevels: "",
      fastAdminToken: localStorage.getItem("fastAdminToken"),
      permissions: JSON.parse(localStorage.getItem("permissions")),
    };
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let students = response.data.data.students;
          this.totalStudents = students.filter((e) => !e.disabled).length;
          this.pendingStudents = students.filter((e) => e.needPay).length;
          let classes = [];
          for(var i in students) {
            if(students[i].class)
              classes.push(students[i].class);
          }
          classes = [...new Set(classes)];
          localStorage.setItem("classes", JSON.stringify(classes));
        }
      })
      

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let teachers = response.data.data.teachers;
          this.totalTeachers = teachers.length;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/levels", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let levels = response.data.data.levels;
          this.totalLevels = levels.length;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h6 {
  margin-top: 10px;
}
</style>
